// @flow
import React, { Component } from 'react';
import { Table, thead, th, tr } from 'react-bootstrap';
import style from './style';

import AdminRow from './components/AdminRow/AdminRow';
import api from '../../../../services/api';


class AdminList extends Component<{
  onAdminSelected: Function,
  filter: string,
}, {
  admins: Array<Object>,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      admins: [],
    };
  }

  componentWillMount() {
    this.loadList();
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps.filter !== this.props.filter) {
      api.admins.search(nextProps.filter, (list: Array<Object>) => {
        this.setState({ admins: list });
      });
    }
  }

  loadList() {
    this.setState({ admins: [] });
    api.admins.getList((list: Array<Object>) => {
      this.setState({ admins: list });
    });
  }

  generateList(): Array<Object> {
    return this.state.admins.map((admin: Object) =>
      (<AdminRow
        key={admin.id}
        mail={admin.email}
        users={admin.userIds.length}
        onClick={() => this.openAdmin(admin)}
      />));
  }

  openAdmin(admin: Object) {
    this.props.onAdminSelected(admin);
  }

  render(): React.Node {
    return (<Table responsive hover style={style.tableStyle}>
      <thead>
        <tr>
          <th>Mail</th>
          <th>Users</th>
        </tr>
      </thead>
      <tbody>
        {this.generateList()}
      </tbody>
    </Table>);
  }
}

export default AdminList;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminList/AdminList.js